import * as React from 'react';
import { ContainerUsage } from 'components/ContainerTracking/ContainerUsage';
import { Box, Divider, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { ArrowUpOnSquareStackIcon, PencilSquareIcon } from '@heroicons/react/24/solid';
import { Manual } from './Manual';
import { RecentlyAdded } from './RecentlyAdded';
import { UploadTab } from '../components/BulkUpload/UploadTab';

export const AddContainers: React.FC = () => {
  const [value, setValue] = React.useState('0');

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div className="p-8 space-y-16">
      <div className="space-y-4">
        <div className="space-y-2">
          <h2 className="font-medium">Add shipments</h2>
          <ContainerUsage variant="simple" />
        </div>
        <Divider />
        <TabContext value={value.toString()}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange}>
              <Tab
                value="0"
                icon={<PencilSquareIcon className="w-5" />}
                iconPosition="start"
                label="Manual Upload"
                className="normal-case px-1 mr-6"
                sx={{
                  '&.MuiTab-root': {
                    minHeight: '3.5em',
                  },
                }}
              />
              <Tab
                value="1"
                icon={<ArrowUpOnSquareStackIcon className="w-5" />}
                iconPosition="start"
                label="Bulk Upload"
                className="normal-case px-1"
                sx={{
                  '&.MuiTab-root': {
                    minHeight: '3.5em',
                  },
                }}
              />
            </TabList>
          </Box>
          <TabPanel value="0" className="p-0 py-2">
            <Manual />
          </TabPanel>
          <TabPanel value="1" className="p-0 py-2">
            <UploadTab />
          </TabPanel>
        </TabContext>
      </div>
      <RecentlyAdded />
    </div>
  );
};
AddContainers.displayName = 'ShippersWatchlist.AddContainers';
